module.exports = __webpack_public_path__ + "static/media/primer_video.e4ea989e.svg";